// shared-lib/group-customization/linkSemantics.js
//
// Names and predicates every reader of a link shares. Stored data may carry
// the older type names (`rail-x`, `centerLine`); readers compare through
// `canonicalType` so both spellings behave identically, and nothing has to
// migrate persisted links to rename a type.
//
// See reference-docs/layout-relationships/overview.md §2.3.

const { pairCopyMirrorChildren } = require('./snapshot');

const TYPE_ALIASES = { 'rail-x': 'center-on', centerLine: 'frame' };

/** Canonical name for a link type; unknown / undefined pass through. */
function canonicalType(type) {
  return TYPE_ALIASES[type] || type;
}

// Members of a rail / center-on share an axis to within real-world noise:
// across the dev corpus 126/127 faucets sit within 0.5" of their sink's
// centreline and every outlier is 2.2"+ (emitVanityLinks.js
// CENTERLINE_TOL_M). The solver's 0.5 mm TRANSLATION_EPS is for exact rp
// offsets; holding "aligned" geometry to it made a rail and an rp on one
// pair disagree mid-drag and reject every move (#1501).
const RAIL_EPS = 0.0127;

/**
 * A copy/mirror link expands to one synthetic pair per matching-type rp
 * child on BOTH parents. With zero pairs it constrains nothing. Legal — it
 * may gain meaning as links are added — but the editor must say so rather
 * than show it beside a working link (#1507).
 *
 * @param {Object} link
 * @param {Object[]} links — the full link list the pairing is read from
 * @param {Map<string,string>} childTypeById
 */
function isInertLink(link, links, childTypeById) {
  if (!link) return false;
  const t = canonicalType(link.type);
  if (t !== 'copy' && t !== 'mirror') return false;
  return pairCopyMirrorChildren(link, links || [], childTypeById).length === 0;
}

module.exports = { TYPE_ALIASES, canonicalType, RAIL_EPS, isInertLink };
